/**
 * Product features bullet list
 */
const ProductFeatures = ({ featuredBullets }) => {
  if (!featuredBullets || featuredBullets.filter((item) => item !== null).length === 0) {
    return null;
  }

  return (
    <div className="pdp-header__features-wrapper">
      <ul className="pdp-header__features-list">
        {featuredBullets
          .filter((item) => item !== null)
          .map((item, index) => (
            <li key={`featured-bullet__${index}`} className="pdp-header__feature-item">
              {item}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ProductFeatures;
